const Builder = require('../BuilderBase');

module.exports = class ForeignRelationTextColumn extends Builder {
    constructor(title, properties) {
        super('listColumn_ForeignRelationText', title, properties);
    }
};
